<template>
  <div class="container">
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      loading-text="Φόρτωση προτύπων εξόδων..."
      no-data-text="Δεν υπάρχουν δεδομένα"
      sort-by="calories"
      class="elevation-1"
      disable-pagination
      disable-filtering
      hide-default-footer
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Πρότυπα έξοδα</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn 
                color="primary" 
                rounded 
                elevation="2" 
                class="mb-2 px-4 font-weight-bold white--text" 
                v-bind="attrs" 
                v-on="on"
              >
                <v-icon left size="20">mdi-plus</v-icon>
                <span>ΔΗΜΙΟΥΡΓΙΑ</span>
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            v-model="editedItem.name"
                            label="Περιγραφή"
                            v-bind:error-messages="allerrors.code">
                        </v-text-field>

                        <v-text-field
                            v-model="editedItem.account_number"
                            label="Λογαριασμός λογιστικής"
                            v-bind:error-messages="allerrors.account_number">
                        </v-text-field>

                        <v-text-field
                            v-model="editedItem.vat_account_number"
                            label="Λογαριασμός ΦΠΑ"
                            v-bind:error-messages="allerrors.vat_account_number">
                        </v-text-field>

                        <v-select
                            label="Κατηγορία ΦΠΑ"
                            v-model="editedItem.vatCategory"
                            v-bind:items="vat_categories"
                            item-text="description"
                            item-value="id"
                            return-object
                            v-bind:error-messages="allerrors.vat_category_id">
                        </v-select>

                        <v-select
                            label="Κατηγορία απαλλαγής ΦΠΑ"
                            v-model="editedItem.vatExemptionCategory"
                            v-bind:items="vat_exemption_categories"
                            item-text="description"
                            item-value="id"
                            clearable
                            return-object
                            v-bind:error-messages="allerrors.vat_exemption_category_id">
                        </v-select>

                        <v-select
                            label="Κατηγορία εξόδου"
                            v-model="editedItem.expenseCategory"
                            v-bind:items="expense_categories"
                            item-text="selectBoxText"
                            item-value="id"
                            return-object
                            v-bind:error-messages="allerrors.expense_category_id">
                        </v-select>

                        <v-select
                            label="Χαρακτηρισμός εξόδου"
                            v-model="editedItem.expenseClassification"
                            v-bind:items="expense_classifications"
                            item-text="selectBoxText"
                            item-value="id"
                            return-object
                            v-bind:error-messages="allerrors.expense_classification_id">
                        </v-select>


                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="warning darken-1" text @click="close">ΑΚΥΡΟ</v-btn>
                <v-btn color="blue darken-1" text @click="save" v-bind:loading="saveButtonDisabled">ΕΝΤΑΞΕΙ</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5">Διαγραφή εγγραφής "{{ editedItem.name }}";</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="warning darken-1" text @click="closeDelete">ΑΚΥΡΟ</v-btn>
                <v-btn color="error darken-1" text @click="deleteItemConfirm" v-bind:loading="deleteButtonDisabled">ΕΝΤΑΞΕΙ</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
        <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  export default {
    data: () => ({
      loading: true,
      moneyFieldOptions: {
          locale: "el-GR",
          prefix: "€",
          suffix: "",
          length: 12,
          precision: 4
      },
      dialog: false,
      dialogDelete: false,
      headers: [
        {
          text: 'Κωδικός',
          align: 'start',
          //sortable: false,
          value: 'name',
        },
        {
          text: 'Λογαριασμός',
          align: 'start',
          //sortable: false,
          value: 'account_number',
        },
        {
          text: 'Λογαριασμός ΦΠΑ',
          align: 'start',
          //sortable: false,
          value: 'vat_account_number',
        },
        { 
          text: 'Κατηγορία ΦΠΑ', 
          value: 'vatCategory.description' 
        },
        { 
          text: 'Κατηγορία απαλλαγής ΦΠΑ', 
          value: 'vatExemptionCategory.description' 
        },
        { 
          text: 'Κατηγορία εξόδου', 
          value: 'expenseCategory.description' 
        },
        { 
          text: 'Χαρακτηρισμός εξόδου', 
          value: 'expenseClassification.description' 
        },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      allerrors: [],
      items: [],
      products: [],
      vat_categories: [],
      vat_exemption_categories: [],
      expense_categories: [],
      expense_classifications: [],

      editedIndex: -1,
      editedItem: {
        code: '',
        account_number: null,
        vat_account_number: null,
        description: '',
        measurementUnit: {},
        vatCategory: {},
        incomeCategory: {},
        suggested_price: 0,
      },
      defaultItem: {
        name: '',
        account_number: null,
        vat_account_number: null,
        vatCategory: {},
        vatExemptionCategory: {},
        expenseCategory: {},
        expenseClassification: {},
        
      },
      saveButtonDisabled: false,
      deleteButtonDisabled: false
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Προσθήκη' : 'Επεξεργασία'
      },

      editedItemName () {
        return 'yay'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      mixmatch(product) {
        product.vatCategory = this.vat_categories.find(x => x.id == product.vat_category_id)
        product.vatExemptionCategory = this.vat_exemption_categories.find(x => x.id == product.vat_exemption_category_id)
        
        
        product.expenseCategory = this.expense_categories.find(x => x.id == product.expense_category_id)
        product.expenseClassification = this.expense_classifications.find(x => x.id == product.expense_classification_id)
        
        return product;
      },

      initialize () {
        this.loading = true;
        axios.all([
          axios.get('/api/tax-authority/vat-categories'),
          axios.get('/api/tax-authority/vat-exemption-categories'),
          axios.get('/api/tax-authority/expense-categories'),
          axios.get('/api/tax-authority/expense-classifications'),
          axios.get('/api/tax-authority/expense-templates')
        ])
        .then(axios.spread((
            vatCategoriesResponse, 
            vatExemptionCategoriesResponse, 
            expenseCategoriesResponse, 
            expenseClassificationsResponse,
            expenseTemplatesResponse
        ) => {
          this.vat_categories = vatCategoriesResponse.data
          this.vat_exemption_categories = vatExemptionCategoriesResponse.data

        const f = function (x) {
            return { 
                ...x, 
                selectBoxText: `${x.tax_authority_code} | ${x.description}`
            }
        }


          this.expense_categories = expenseCategoriesResponse.data.map(f)
          this.expense_classifications = expenseClassificationsResponse.data.map(f)
          
          this.expenseTemplates = expenseTemplatesResponse.data

          this.items = this.expenseTemplates.map(product => this.mixmatch(product))

        }))
        .catch(error => { console.log(error) }).finally(() => { this.loading = false; })
      },

      editItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.deleteButtonDisabled = true;
        axios.delete(`/api/tax-authority/expense-templates/${this.items[this.editedIndex].id}`)
        .then(response => { this.items.splice(this.editedIndex, 1); this.closeDelete(); })
        .catch(error => console.log(error))
        .finally(() => this.deleteButtonDisabled = false)
      },

      close () {
        this.allerrors = []
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        this.saveButtonDisabled = true;
        
        let requestBody = {
          name: this.editedItem.name,
          vat_category_id: this.editedItem.vatCategory.id,
          
          expense_category_id: this.editedItem.expenseCategory.id,
          expense_classification_id: this.editedItem.expenseClassification.id,
          account_number: null,
          vat_account_number: null,
        }

        if (this.editedItem.vatExemptionCategory?.id > 0)
          requestBody.vat_exemption_category_id = this.editedItem.vatExemptionCategory.id

        if (this.editedItem.account_number?.length > 0)
          requestBody.account_number = this.editedItem.account_number

        if (this.editedItem.vat_account_number?.length > 0)
          requestBody.vat_account_number = this.editedItem.vat_account_number

        if (this.editedIndex > -1) {
          //Object.assign(this.items[this.editedIndex], this.editedItem)
          axios.patch(`/api/tax-authority/expense-templates/${this.editedItem.id}`, requestBody )
          .then(response => { Object.assign(this.items[this.editedIndex], this.mixmatch(response.data)); this.close(); })
          .catch(error => {
            console.log(error)

            if (error.response.data.errors)
              this.allerrors = error.response.data.errors

          })
          .finally(() => this.saveButtonDisabled = false)
        } else {

          axios.post('/api/tax-authority/expense-templates', requestBody )
          .then(response => { console.log(response.data); this.items.push(this.mixmatch(response.data)); this.close(); })
          .catch(error => {
            console.log(error)

            if (error.response.data.errors)
              this.allerrors = error.response.data.errors

          })
          .finally(() => this.saveButtonDisabled = false)
          
        }
      },
    },
  }
</script>

<style>
</style>